import React from 'react';
import RouteList from '../components/routes/RouteList';

export default function RoutesPage() {
  return <RouteList />;
}
